module.exports = require('./lib/uslug');


//////////////////
// WEBPACK FOOTER
// ./~/uslug/index.js
// module id = 266
// module chunks = 0